<script>import TimeSeriesPlot from "../../d3/TimeSeriesPlot.svelte";
export let plotDefinition;
export let startMarker = void 0;
export let endMarker = void 0;
</script>
  
  <div>
    <div class="header">
      <h3>{plotDefinition.properties.title}</h3>
    </div>
    <TimeSeriesPlot
    role={"plot"}
    showAxis={true}
    separate={true}
    bind:startMarker
    bind:endMarker>
    <svelte:component this={plotDefinition.type} {...plotDefinition.properties}  />
  </TimeSeriesPlot>
  </div>
  